// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"221":"7897d26c","476":"02fd1aaf","561":"b7916003","609":"65b8e48a","821":"2560ae12","850":"1fb93d3f"}[chunkId] + ".chunk.css";
};